import React, { useState } from 'react';
import { Form, Button, Container, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { addEvent } from '../../services/eventService';
import { message } from 'antd'; // Add antd message

const EventForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    date: '',
    header: '',
    detail: '',
    location: '',
    mapLocationCode: '',
    picture: null,
    file: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      // Validate image file
      if (fieldName === 'picture') {
        // Check if file is an image
        if (!file.type.startsWith('image/')) {
          message.warning('Lütfen geçerli bir resim dosyası seçin');
          e.target.value = '';
          return;
        }
        // Check image size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
          message.warning('Resim dosyası 5MB\'dan büyük olamaz');
          e.target.value = '';
          return;
        }
      } else {
        // Validate attachment file
        // Check file size (max 10MB)
        if (file.size > 10 * 1024 * 1024) {
          message.warning('Dosya boyutu 10MB\'dan büyük olamaz');
          e.target.value = '';
          return;
        }
        // Check file type
        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if (!allowedTypes.includes(file.type)) {
          message.warning('Sadece PDF ve Word dosyaları kabul edilmektedir');
          e.target.value = '';
          return;
        }
      }

      setFormData(prevState => ({
        ...prevState,
        [fieldName]: file
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [fieldName]: null
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await addEvent(formData);
      if (response.isSuccess) {
        message.success('Etkinlik başarıyla eklendi!');
        
        setTimeout(() => {
          navigate('/events');
        }, 1500);
      } else {
        message.error(response.resultMessage || 'Etkinlik eklenirken bir hata oluştu.');
      }
    } catch (error) {
      console.error('Error adding event:', error);
      const errorMessage = error.response?.data?.message || 'Etkinlik eklenirken bir hata oluştu.';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>


      <Card className="mt-4 mb-4">
        <Card.Body>
          <h2 className="mb-4">Yeni Etkinlik Ekle</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Etkinlik Başlığı</Form.Label>
              <Form.Control
                type="text"
                name="header"
                value={formData.header}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Etkinlik Tarihi</Form.Label>
              <Form.Control
                type="datetime-local"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Konum</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Harita Konum Kodu</Form.Label>
              <Form.Control
                type="text"
                name="mapLocationCode"
                value={formData.mapLocationCode}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Detay</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="detail"
                value={formData.detail}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Etkinlik Görseli</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, 'picture')}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Ek Dosya</Form.Label>
              <Form.Control
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(e) => handleFileChange(e, 'file')}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button 
                variant="secondary" 
                onClick={() => navigate('/events')}
                disabled={loading}
              >
                İptal
              </Button>
              <Button 
                variant="primary" 
                type="submit"
                disabled={loading}
              >
                {loading ? 'Ekleniyor...' : 'Kaydet'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default EventForm;
